import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSimulations, scheduleSimulation, patchSimulation } from '../../services/api/simLabService';

export const loadSimulations = createAsyncThunk('simLab/load', async () => fetchSimulations());

export const createSimulation = createAsyncThunk('simLab/create', async (payload, { rejectWithValue }) => {
  try { return await scheduleSimulation(payload); }
  catch (err) { return rejectWithValue(err?.response?.data?.message || err?.response?.data?.detail || 'Could not schedule this exercise.'); }
});

export const updateSimulation = createAsyncThunk(
  'simLab/update',
  async ({ id, changes }, { rejectWithValue }) => {
    try { return await patchSimulation(id, changes); }
    catch (err) { return rejectWithValue(err?.response?.data?.message || err?.response?.data?.detail || 'Could not update this session.'); }
  }
);

const simLabSlice = createSlice({
  name: 'simLab',
  initialState: { status: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadSimulations.pending, (state) => { state.status = 'loading'; })
      .addCase(loadSimulations.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(loadSimulations.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(createSimulation.fulfilled, (state, action) => {
        state.error = null;
        state.items.unshift(action.payload);
      })
      .addCase(createSimulation.rejected, (state, action) => {
        state.error = action.payload || action.error.message;
      })
      .addCase(updateSimulation.fulfilled, (state, action) => {
        state.error = null;
        const item = state.items.find((s) => s.id === action.payload.id);
        if (item) Object.assign(item, action.payload);
      })
      .addCase(updateSimulation.rejected, (state, action) => {
        state.error = action.payload || action.error.message;
      });
  }
});

export default simLabSlice.reducer;
